import React from "react";
import { Banner } from "kubra-ux-forge";

export interface WelcomeMessageBannerProps {
  messageLabel: string;
  linkText?: string;
  onClick: () => void;
}

export const WelcomeMessageBanner = ({
  messageLabel,
  linkText,
  onClick,
}: WelcomeMessageBannerProps): JSX.Element => {
  return (
    <Banner
      variant="info"
      active
      withIcon
      withHyperlink={!!linkText}
      messageLabel={messageLabel}
      hyperlinkText={linkText}
      hyperlink={onClick}
      data-cy="welcome-banner"
    />
  );
};
